var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityOrangeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 107,
    viewBox: "0 0 98 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 8.73333C13 13.2667 2.99999 17.5333 2.99999 18.3333C2.99999 20.2 45.5333 43 49 43C52.6 43 95 20.2 95 18.3333C95 17.1333 50.4667 0.0666644 48.3333 0.466664C47.9333 0.466664 37.6667 4.2 25.4 8.73333ZM87.1333 18.2C87.1333 18.8667 78.7333 23.9333 68.3333 29.4C51 38.4667 49 39.1333 45.8 37.6667C42.4667 36.0667 43 35.6667 61.6667 26.2C79.1333 17.2667 87 14.8667 87.1333 18.2Z",
    fill: "#F2A900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26666 25.1333C0.733328 25.6667 0.333328 37.1333 0.333328 50.4667V74.8667L6.06666 79.4C19.2667 89.9333 43.2667 105.8 45.1333 105.133C46.6 104.6 47 99.6667 47 78.3333C47 63.5333 46.4667 51.1333 45.6667 49.6667C45 48.3333 35.2667 42.2 24.0667 36.0667C-0.0666718 22.8667 2.33333 24.0667 1.26666 25.1333Z",
    fill: "#F2A900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6667 36.2L53 47.8L52.6 77.4C52.4667 93.6667 52.6 107 53.1333 107C53.5333 107 63.4 100.067 75.1333 91.5333C88.3333 81.9333 96.6 75 97 73.2667C98.3333 68.0667 97.1333 25.2667 95.6667 24.8667C95 24.7333 85 29.8 73.6667 36.2Z",
    fill: "#F2A900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityOrangeIcon);
export default __webpack_public_path__ + "static/media/activity-orange-icon.a7bde8e65a84878d42c548501f30aa55.svg";
export { ForwardRef as ReactComponent };